import { Action } from 'redux';

import {
    SET_USER_ID,
    SET_CHANNEL_ID,
    SET_USER_PHONE,
    SET_USER_CODE,
    SET_CHANNEL_USER_ID,
    SET_USER_LANG,
    SET_TARIFF_ID,
    ASK_KONSIERGE_REQUEST,
    ASK_KONSIERGE_RESPONSE,
    ASK_KONSIERGE_ERROR
} from '../actions/user';
import { RESET_AUTHORIZATION, AUTHORIZATION_REQUEST, AUTHORIZATION_SEND_CODE_REQUEST, RESET_SEND_CODE_AUTHORIZATION, AUTHORIZATION_SEND_CODE_RESPONSE, AUTHORIZATION_SEND_CODE_ERROR } from '../actions/Authorization/authorization';
import { RESET_REGISTRATION, RESET_SEND_CODE_REGISTRATION, REGISTRATION_SEND_CODE_RESPONSE, REGISTRATION_SEND_CODE_ERROR } from '../actions/Registration/registration';

export interface UserState {
    userId: string;
    channelId: string;
    channelUserId: string;
    phone: string;
    code: string;
    lang: string;
    tariffId: number;
    loadingAskKonsierge: boolean;
    errorAskKonsierge: string;
}

const initialState: UserState = {
    userId: '',
    channelId: '',
    channelUserId: '',
    phone: '',
    code: '',
    lang: 'ru',
    tariffId: 0,
    loadingAskKonsierge: false,
    errorAskKonsierge: ''
};

export function userState(state: UserState = initialState, action: Action) {
    switch (action.type) {
        case AUTHORIZATION_SEND_CODE_RESPONSE: {
            const userId = (action as any).response.result.token;
            return {
                ...state,
                userId,
            };
        }
        case REGISTRATION_SEND_CODE_RESPONSE: {
            const userId = (action as any).response.result.token;
            return {
                ...state,
                userId,
            };
        }
        case RESET_AUTHORIZATION:
        case RESET_SEND_CODE_AUTHORIZATION:
        case RESET_REGISTRATION:
        case RESET_SEND_CODE_REGISTRATION:
        case AUTHORIZATION_REQUEST:
        case AUTHORIZATION_SEND_CODE_REQUEST:
        case REGISTRATION_SEND_CODE_ERROR:
        case AUTHORIZATION_SEND_CODE_ERROR: {
            return {
                ...state,
                code: initialState.code,
            };
        }

        case SET_USER_ID: {
            const userId = (action as any).userId;
            if (userId) {
                localStorage.KON_USER_ID = userId;
            }
            return {
                ...state,
                userId: localStorage.KON_USER_ID,
            };
        }
        case SET_CHANNEL_USER_ID: {
            const channelUserId = (action as any).channelUserId;
            return {
                ...state,
                channelUserId,
            };
        }
        case SET_CHANNEL_ID: {
            const channelId = (action as any).channelId;
            if (channelId) {
                localStorage.KON_CHANNEL_ID = channelId;
            }
            return {
                ...state,
                channelId: localStorage.KON_CHANNEL_ID,
            };
        }
        case SET_USER_PHONE: {
            const phone = (action as any).phone;
            return {
                ...state,
                phone,
            };
        }
        case SET_USER_CODE: {
            const code = (action as any).code;
            return {
                ...state,
                code,
            };
        }
        case SET_USER_LANG: {
            const lang = (action as any).lang;
            if (lang) {
                localStorage.KON_LANG = lang;
            }
            return {
                ...state,
                lang,
            };
        }
        case SET_TARIFF_ID: {
            const tariffId = (action as any).tariffId;
            if (tariffId) {
                localStorage.KON_TARIFF_ID = tariffId;
            }
            return {
                ...state,
                tariffId
            };
        }
        case ASK_KONSIERGE_REQUEST: {
            return {
                ...state,
                loadingAskKonsierge: true,
                errorAskKonsierge: initialState.errorAskKonsierge
            };
        }
        case ASK_KONSIERGE_RESPONSE: {
            return {
                ...state,
                loadingAskKonsierge: initialState.loadingAskKonsierge
            };
        }
        case ASK_KONSIERGE_ERROR: {
            const errorAskKonsierge = (action as any).error;
            return {
                ...state,
                loadingAskKonsierge: initialState.loadingAskKonsierge,
                errorAskKonsierge
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/user.ts